import InfoResultsPerformanceModel from "./InfoResultsPerformanceModel"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import "../css/ModelEvalResults.css"

type ModelsEvaluationResultsProps= {
  infoCompetencies:any
}

const ModelsEvaluationResults = ({infoCompetencies}:ModelsEvaluationResultsProps) => {
  
  return (
   <>    
 <TableContainer >
      <Table sx={{ minWidth: 500 }} aria-label="simple table">
        <TableBody>
          {
           infoCompetencies.map((row:any) => (
            <TableRow
              key={row.idCompetencies}            
            >
              <TableCell>
              <div className="containerEvalRes">
                <div className="containerInfoEvalPerRes">
                    <div><span className="titleModelEvalRes">{row.nameCompetence}</span> </div>  
                    <div><span className="descModelEvalRes">{row.DescriptionCompetence}</span></div>         
                </div>
                <div className="containerResultsEval">
                <InfoResultsPerformanceModel
                 name={row.nameCompetence}
                 infoEval={row.infoEvalByCompetence}
                 numberCompetencies={infoCompetencies.length}
                />
              </div>  
              </div>  
              </TableCell>
              
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>   
    </>
  )
}

export default ModelsEvaluationResults

